import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const MobileKhata = dynamic(() => import('../../components/khata/MobileKhata'), {
    loading: () => <Loading />,
})
const DesktopKhata = dynamic(() => import('../../components/khata/DesktopKhata'), {
    loading: () => <Loading />,
})
const khataManagementSoftware = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>QB Khata- Udhar Bahi Khata & Ledger Accounting Software</title>
                <link rel="canonical" href="https://queuebuster.co/features/khata-management-software" />
                <link rel="alternate" href="https://queuebuster.co/features/khata-management-software" hrefLang="en-us" />
                <meta name="description" content="QB Khata: Simplify Udhar Bahi Khata & ledger accounting. Track credit, debts, and customer accounts digitally. Streamline your business finances effortlessly." />
                <meta property="og:title" content="QB Khata- Udhar Bahi Khata & Ledger Accounting Software Free with POS Billing Software" />
                <meta property="og:description" content="Manage your Udhar Bahi Khata effortlessly with QB Khata, the ultimate ledger accounting software. Keep track of credit transactions, debts, and customer accounts digitally. Try it today for efficient and hassle-free accounting software with POS." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/khata-og%2B(2).jpg" />
                <meta property="og:url" content="https://queuebuster.co/features/khata-management-software" />
            </Head>
            <SchemaTags page="khata-management-software" />
            {mobileView ? <MobileKhata /> : <DesktopKhata />}
        </>
    )
}

export default khataManagementSoftware
